import React from 'react';
import { IconProps } from '.';

const SvgUnmute = ({
  size = 16,
  color = '#292B2B',
  secondaryColor = '#B3BABD',
  className,
  ...props
}: IconProps): JSX.Element => {
  return (
    <svg
      width={size}
      height={size}
      fill='none'
      viewBox='0 0 24 24'
      className={className ? 'pds-icon ' + className : 'pds-icon'}
      {...props}
    >
      <path
        fill={color}
        fillRule='evenodd'
        d='M6.5 7H2v10h4.5l7.5 4V3L6.5 7Zm6-1.5-5.625 3H3.5v7h3.375l5.625 3v-13Z'
        clipRule='evenodd'
      />
      <path fill={color} d='M20.25 18V6h1.5v12h-1.5ZM16.25 9v6h1.5V9h-1.5Z' />
    </svg>
  );
};

export default SvgUnmute;
